import React from "react";
import { ButtonPrimary } from "../common/ButtonPrimary";

const SaveDiscountCouponSection = ({
  loading,
  onSave,
}: {
  loading: boolean;
  onSave: () => void;
}) => {
  return (
    <div className="flex justify-end w-full">
      <ButtonPrimary
        disabled={loading}
        className="rounded-full px-8 h-[50px]"
        onClick={onSave}
      >
        Save
      </ButtonPrimary>
    </div>
  );
};

export default SaveDiscountCouponSection;
